import { render } from "./ProductComp.vue?vue&type=template&id=72ad821e&scoped=true"
import script from "./ProductComp.vue?vue&type=script&lang=js"
export * from "./ProductComp.vue?vue&type=script&lang=js"

import "./ProductComp.vue?vue&type=style&index=0&id=72ad821e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ad821e"]])

export default __exports__